import { render, staticRenderFns } from "./NotFound-404.vue?vue&type=template&id=548065e1"
import script from "./NotFound-404.vue?vue&type=script&lang=js"
export * from "./NotFound-404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports